/**
 * @file Identity Update action.
 */
import { photoUploadSuccess } from '../../../../actions/photo-upload';
import getLogger from '../../../../util/logger';
import { getErrorString } from '../../../../util/normalize-errors';

const log = getLogger('IdentityUpdateAction');

export const IDENTITY_UPDATE_REQUEST = 'identity/UPDATE_REQUEST';
export const IDENTITY_UPDATE_SUCCESS = 'identity/UPDATE_SUCCESS';
export const IDENTITY_UPDATE_FAILURE = 'identity/UPDATE_FAILURE';
export const IDENTITY_UPDATE_RESET = 'identity/UPDATE_RESET';

const identityUpdateRequest = () => {
  return { type: IDENTITY_UPDATE_REQUEST };
};

const identityUpdateSuccess = identity => {
  return { type: IDENTITY_UPDATE_SUCCESS, identity };
};

const identityUpdateFailure = error => {
  return { type: IDENTITY_UPDATE_FAILURE, error };
};

const identityUpdateReset = () => {
  return { type: IDENTITY_UPDATE_RESET };
};

export const identityUpdate = ({
  identity,
  identityFirstName,
  identityLastName,
  gender,
  file,
  identityUpdateMutation,
  updateSelfieMutation,
}) => async dispatch => {
  log.info('identityUpdate() :: Updating identity...', identity.id);

  if (!identityFirstName && !identityLastName && !gender && !file) {
    return;
  }

  dispatch(identityUpdateRequest());

  try {
    if (identityFirstName || identityLastName || gender) {
      const identityUpdateRes = await identityUpdateMutation({
        identityId: identity.id,
        firstName: identityFirstName,
        lastName: identityLastName,
        gender,
      });

      if (!file) {
        log.info('identityUpdate() :: Identity details updated');
        const {
          identity: updatedIdentity,
        } = identityUpdateRes.data.identityUpdate;
        dispatch(identityUpdateSuccess(updatedIdentity));
        return;
      }
    }

    const updateSelfieRes = await updateSelfieMutation(identity.id, file.id);

    dispatch(photoUploadSuccess({ identityId: identity.id, ...file }));

    const { identity: updatedIdentity } = updateSelfieRes.data.updateSelfie;

    log.info('identityUpdate() :: Identity updated');

    dispatch(identityUpdateSuccess(updatedIdentity));
  } catch (error) {
    log.error('identityUpdate() :: Error:', error);

    dispatch(identityUpdateFailure(getErrorString(error)));
  }
};

export const identityUpdateResetAction = () => dispatch => {
  dispatch(identityUpdateReset());
};
